import {  all,  takeEvery } from 'redux-saga/effects';
import dataAPI  from './dataSaga';
//import projectsCategoriesAPI  from './projectsCategoriesSaga';
// import pocketAPI from './pocketSagas';

export default function* rootSaga() {

  yield all([
    takeEvery('data/getData', dataAPI),
    // takeEvery('project/projectsCategoriesData', projectsCategoriesAPI),
    // takeEvery('pocket/pocketData', pocketAPI)
  ])
}
